<div class="auth-page">
  <img *ngIf="logoUrl" [src]="logoUrl" alt="Capiche" class="auth-logo">
  <router-outlet></router-outlet>
</div>
